export const assessmentQuestions = [
  {
    id: "market_strategy_1",
    category: "Market Strategy",
    question: "How well-defined is your target market?",
    description: "Understanding your ideal customer profile and market segments is crucial for GTM success.",
    options: [
      {
        text: "We have detailed buyer personas and clear market segments",
        description: "Comprehensive market research and segmentation completed",
        score: 100,
      },
      {
        text: "We have a general idea of our target market",
        description: "Basic understanding but lacks detailed segmentation",
        score: 60,
      },
      {
        text: "Our target market is broadly defined",
        description: "Limited market research and unclear segmentation",
        score: 30,
      },
      {
        text: "We are still figuring out our target market",
        description: "No clear market definition or buyer personas",
        score: 0,
      },
    ],
  },
  {
    id: "product_market_fit_1",
    category: "Product Market Fit",
    question: "How strong is the demand for your product/service?",
    description: "Product-market fit indicates how well your product satisfies market demand.",
    options: [
      {
        text: "High demand with strong customer retention and referrals",
        description: "Clear evidence of product-market fit with organic growth",
        score: 100,
      },
      {
        text: "Moderate demand with some customer traction",
        description: "Good initial response but room for improvement",
        score: 70,
      },
      {
        text: "Limited demand, struggling to gain traction",
        description: "Some interest but low conversion and retention",
        score: 40,
      },
      {
        text: "Very low demand, significant product-market fit issues",
        description: "Little to no market validation or customer interest",
        score: 10,
      },
    ],
  },
  {
    id: "sales_process_1",
    category: "Sales Process",
    question: "How structured and effective is your sales process?",
    description: "A well-defined sales process is essential for predictable revenue growth.",
    options: [
      {
        text: "Highly structured with documented processes and consistent results",
        description: "Clear sales methodology with proven conversion rates",
        score: 100,
      },
      {
        text: "Somewhat structured with room for improvement",
        description: "Basic processes in place but inconsistent execution",
        score: 65,
      },
      {
        text: "Ad-hoc approach with limited structure",
        description: "Informal sales process with unpredictable results",
        score: 35,
      },
      {
        text: "No formal sales process in place",
        description: "Completely unstructured approach to sales",
        score: 0,
      },
    ],
  },
  {
    id: "marketing_channels_1",
    category: "Marketing Channels",
    question: "How effective are your marketing channels in reaching your target audience?",
    description: "The right marketing mix is crucial for efficient customer acquisition.",
    options: [
      {
        text: "Multiple high-performing channels with strong ROI",
        description: "Diversified marketing mix with proven channel effectiveness",
        score: 100,
      },
      {
        text: "Few channels working well, others underperforming",
        description: "Some successful channels but limited diversification",
        score: 70,
      },
      {
        text: "Limited channels with inconsistent performance",
        description: "Few marketing channels with unclear ROI",
        score: 40,
      },
      {
        text: "Struggling to find effective marketing channels",
        description: "No clear successful marketing channels identified",
        score: 10,
      },
    ],
  },
  {
    id: "customer_success_1",
    category: "Customer Success",
    question: "How well do you retain and grow your existing customers?",
    description: "Customer success drives retention, expansion, and referrals.",
    options: [
      {
        text: "High retention with strong expansion revenue",
        description: "Excellent customer success metrics and growth",
        score: 100,
      },
      {
        text: "Good retention with some expansion opportunities",
        description: "Solid customer success but room for improvement",
        score: 75,
      },
      {
        text: "Average retention with limited expansion",
        description: "Basic customer success with minimal growth",
        score: 45,
      },
      {
        text: "Poor retention and high churn rates",
        description: "Significant customer success challenges",
        score: 15,
      },
    ],
  },
  {
    id: "team_resources_1",
    category: "Team & Resources",
    question: "How well-equipped is your team to execute your GTM strategy?",
    description: "Having the right team and resources is fundamental to GTM success.",
    options: [
      {
        text: "Fully staffed with experienced team members",
        description: "Complete team with relevant expertise and adequate resources",
        score: 100,
      },
      {
        text: "Good team but some skill gaps or resource constraints",
        description: "Strong foundation but areas needing development",
        score: 70,
      },
      {
        text: "Limited team with significant gaps",
        description: "Basic team structure with major skill or resource gaps",
        score: 40,
      },
      {
        text: "Severely understaffed or lacking key expertise",
        description: "Insufficient team or resources to execute effectively",
        score: 10,
      },
    ],
  },
]
